import httpMixin from "@/v2/mixins/http.js";
import mapperMixin from "@/v2/mixins/mapper.js";
import { TierMapperParameter, TierFactory } from "@/v2/models/tiers.js";

export default {
    mixins: [httpMixin, mapperMixin],
    methods: {
        _tierMapper(tier) {
            return {
                id: tier.id,
                name: tier.name,
                remark: tier.remark,
                bo_can_delete: true,
                show_action_menu: true,
            };
        },

        parseTier(tier) {
            return TierFactory.construct(this.createMapperParameter(new TierMapperParameter()), tier);
        },

        parseTiers(tiers) {
            let parsedTiers = [];

            tiers.forEach((tierData) => {
                const tier = this.parseTier(tierData);
                parsedTiers.push(tier);
            });
            return parsedTiers;
        },

        getTiers(url, payload, success, failure) {
            return this.getData(
                url,
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },
    },
};
